import React from 'react'
import PropTypes from 'prop-types'

import './button.scss'

const ButtonBar = ({ children, sticky }) => (
  <div className={`buttons-bar ${sticky && 'sticky-button-bar'}`}>
    {children}
  </div>
)

ButtonBar.defaultProps = {
  sticky: false,
}

ButtonBar.propTypes = {
  children: PropTypes.array,
  sticky: PropTypes.bool,
}

export default ButtonBar
